import React, { useState } from "react";
import Modal from "../../components/common/Modal";
import "./Feemanagement.scss";

const defaultReminder = {
  frequency: "monthly",
  weekDay: "Monday",
  monthDay: "1",
  times: ["09:00"],
};

const initialFormState = {
  academicYear: "",
  invoicePrefix: "STPS",
  invoiceNumber: "1",
  paymentGateway: "",
  cancellationOption: "",
  feeReminder: "",
};

const buildScheduleText = (reminder) => {
  const timesText = reminder.times.join(", ");

  if (reminder.frequency === "daily") {
    return `Daily @ ${timesText}`;
  }

  if (reminder.frequency === "weekly") {
    return `Weekly on ${reminder.weekDay} @ ${timesText}`;
  }

  return `Monthly on ${reminder.monthDay} @ ${timesText}`;
};

const FeeSettings = () => {

  const [showViewModal, setShowViewModal] = useState(false);
  const [showViewModal2, setShowViewModal2] = useState(false);
  const [form, setForm] = useState(initialFormState);

  // every fee-settings row now lives in state, instead of one hardcoded <tr>
  const [feeSettingsList, setFeeSettingsList] = useState([
    {
      academicYear: "2025-2026",
      invoicePrefix: "STPS",
      invoiceNumber: "1",
      status: true,
      reminderEnabled: false,
      reminder: { ...defaultReminder },
    },
  ]);

  // which row the "Configure" modal is currently editing
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFeeSettingsList((prev) => [
      ...prev,
      {
        academicYear: form.academicYear,
        invoicePrefix: form.invoicePrefix,
        invoiceNumber: form.invoiceNumber,
        status: true,
        reminderEnabled: false,
        reminder: { ...defaultReminder },
      },
    ]);

    setForm(initialFormState);
    setShowViewModal(false);
  };

  const handleCancelAdd = () => {
    setForm(initialFormState);
    setShowViewModal(false);
  };

  const toggleStatus = (index) => {
    setFeeSettingsList((prev) =>
      prev.map((row, i) => (i === index ? { ...row, status: !row.status } : row))
    );
  };

  const toggleReminderEnabled = (index) => {
    setFeeSettingsList((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, reminderEnabled: !row.reminderEnabled } : row
      )
    );
  };

  // timepicker — fields for whichever row is currently being configured
  const [frequency, setFrequency] = useState("monthly");
  const [times, setTimes] = useState(["09:00"]);
  const [weekDay, setWeekDay] = useState("Monday");
  const [monthDay, setMonthDay] = useState("1");

  const openConfigure = (index) => {
    const row = feeSettingsList[index];
    setActiveRowIndex(index);
    setFrequency(row.reminder.frequency);
    setWeekDay(row.reminder.weekDay);
    setMonthDay(row.reminder.monthDay);
    setTimes(row.reminder.times);
    setShowViewModal2(true);
  };

  const addTime = () => {
    setTimes([...times, "09:00"]);
  };

  const updateTime = (index, value) => {
    const updated = [...times];
    updated[index] = value;
    setTimes(updated);
  };

  const removeTime = (index) => {
    setTimes(times.filter((_, i) => i !== index));
  };

  const handleSaveReminder = () => {
    if (activeRowIndex === null) return;

    const reminder = { frequency, weekDay, monthDay, times };

    setFeeSettingsList((prev) =>
      prev.map((row, i) => (i === activeRowIndex ? { ...row, reminder } : row))
    );

    setShowViewModal2(false);
  };

  return (

    <>
      <div className="page-header mb-3">
        <div><h2> LIST OF FEES SETTINGS</h2></div>
        <button className="btn btn-primary" onClick={() => setShowViewModal(true)} >➕ Add Fee</button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="table-responsive border">
            <table className="table fee-table">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Academic year name</th>
                  <th>Invoice number starting from</th>
                  <th>Status</th>
                  <th>Fee Reminder</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                {feeSettingsList.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.academicYear || "—"}</td>
                    <td>{row.invoicePrefix}{row.invoiceNumber}</td>

                    <td>
                      <button
                        type="button"
                        className={`btn btn-sm ${row.status ? "btn-success" : "btn-danger"}`}
                        onClick={() => toggleStatus(index)}
                      >
                        {row.status ? "Active" : "Inactive"}
                      </button>
                    </td>

                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className={`btn btn-sm ${row.reminderEnabled ? "btn-success" : "btn-outline-dark"}`}
                          onClick={() => toggleReminderEnabled(index)}
                        >
                          {row.reminderEnabled ? "Enabled" : "Disabled"}
                        </button>

                        <button className="configure-btn" onClick={() => openConfigure(index)}>
                          <i className="bi bi-clock-fill me-1"></i>
                          Configure
                        </button>
                      </div>

                      <div className="schedule">
                        {buildScheduleText(row.reminder)}
                      </div>
                    </td>

                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button className="export-btn">
            Export to Excel
          </button>

          <div className="note-section">
            <strong>Note :</strong>
            <span>
              {" "}
              Fee settings cannot edit or delete if any transactions made with
              same fee settings
            </span>
          </div>

        </div>
      </div>

      <Modal
        show={showViewModal}
        onClose={() => setShowViewModal(false)}
        title="Add Fee Settings"
        size="lg"
      >
        <div className="container-fluid">
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">

              {/* Academic Year */}
              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">
                    Academic Year Name
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="academicYear"
                    value={form.academicYear}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Invoice Number */}
              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">
                    Invoice Number Starting From
                  </label>

                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control"
                      style={{ maxWidth: "150px" }}
                      name="invoicePrefix"
                      value={form.invoicePrefix}
                      onChange={handleChange}
                    />

                    <span className="mx-2">-</span>

                    <input
                      type="number"
                      className="form-control"
                      style={{ maxWidth: "150px" }}
                      name="invoiceNumber"
                      value={form.invoiceNumber}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Payment Gateway */}
              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">
                    Payment Gateway
                  </label>

                  <select
                    className="form-select"
                    name="paymentGateway"
                    value={form.paymentGateway}
                    onChange={handleChange}
                  >
                    <option value="">--- Select ---</option>
                    <option value="razorpay">Razorpay</option>
                    <option value="stripe">Stripe</option>
                    <option value="paytm">Paytm</option>
                  </select>
                </div>
              </div>

              {/* Invoice Cancellation */}
              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">
                    Invoice Cancellation Option
                  </label>

                  <select
                    className="form-select"
                    name="cancellationOption"
                    value={form.cancellationOption}
                    onChange={handleChange}
                  >
                    <option value="">--- Select ---</option>
                    <option value="yes">Enable</option>
                    <option value="no">Disable</option>
                  </select>
                </div>
              </div>

              {/* Fee Reminder */}
              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">
                    Fee Reminders
                  </label>

                  <select
                    className="form-select"
                    name="feeReminder"
                    value={form.feeReminder}
                    onChange={handleChange}
                  >
                    <option value="">--- Select ---</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>
              </div>

              {/* Buttons */}
              <div className="row">
                <div className="col-md-8">
                  <button
                    type="submit"
                    className="btn btn-info text-white me-2 px-4"
                  >
                    Submit
                  </button>

                  <button
                    type="button"
                    className="btn btn-light border px-4"
                    onClick={handleCancelAdd}
                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </Modal>

      <Modal
        show={showViewModal2}
        onClose={() => setShowViewModal2(false)}
        title="Fee Reminder Schedule"
        size="md"
      >
        <div className="container-fluid">
          <div className="mb-4">
            <label className="form-label fw-semibold">
              Reminder Frequency
            </label>

            <select
              className="form-select"
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>

          {frequency === "weekly" && (
            <div className="mb-4">
              <label className="form-label fw-semibold">
                Day of Week
              </label>

              <select
                className="form-select"
                value={weekDay}
                onChange={(e) => setWeekDay(e.target.value)}
              >
                <option>Monday</option>
                <option>Tuesday</option>
                <option>Wednesday</option>
                <option>Thursday</option>
                <option>Friday</option>
                <option>Saturday</option>
                <option>Sunday</option>
              </select>
            </div>
          )}

          {frequency === "monthly" && (
            <div className="mb-4">
              <label className="form-label fw-semibold">
                Day of Month
              </label>

              <select
                className="form-select"
                value={monthDay}
                onChange={(e) => setMonthDay(e.target.value)}
              >
                {[...Array(31)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="mb-3">
            <label className="form-label fw-semibold">
              Send Times
            </label>

            {times.map((time, index) => (
              <div
                key={index}
                className="d-flex align-items-center gap-2 mb-2"
              >
                <div className="input-group" style={{ maxWidth: "220px" }}>
                  <span className="input-group-text">
                    <i className="bi bi-clock"></i>
                  </span>

                  <input
                    type="time"
                    className="form-control"
                    value={time}
                    onChange={(e) =>
                      updateTime(index, e.target.value)
                    }
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeTime(index)}
                >
                  <i className="bi bi-trash icon-sm text-white"></i>
                </button>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-outline-primary mt-2"
              onClick={addTime}
            >
              <i className="bi bi-plus-lg me-1"></i>
              Add Time
            </button>
          </div>

          <hr />
          <div className="row">
            <div className="col-md-12 text-center">
              <button
                type="button"
                className="btn btn-info text-white me-2 px-4"
                onClick={handleSaveReminder}
              >
                Submit
              </button>

              <button
                type="button"
                className="btn btn-light border px-4"
                onClick={() => setShowViewModal2(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FeeSettings;